var React = require('react');

function ModernTech (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#6C6B6B","fillRule":"evenodd","d":"M6.25391 28.7848c1.05961-3.4234 2.11923-6.8875 3.17884-10.3924A8563.4577 8563.4577 0 0 1 12.6422 8h7.3052c1.0596 3.4234 2.1192 6.8875 3.1789 10.3924 1.08 3.5049 2.1498 6.969 3.2094 10.3924h-5.3796a71.08233 71.08233 0 0 1-.5808-1.9562c-.1834-.6725-.3769-1.3347-.5807-1.9868H12.795c-.2038.6521-.3974 1.3143-.5808 1.9868-.1833.652-.3769 1.3041-.5807 1.9562H6.25391Zm7.88599-8.4973h4.3098c-.3464-1.2023-.703-2.4147-1.0698-3.6374-.3668-1.2226-.7234-2.435-1.0698-3.6373-.3464 1.2023-.7132 2.4147-1.1004 3.6373a346.84239 346.84239 0 0 0-1.0698 3.6374Z","clipRule":"evenodd","key":0}),React.createElement("path",{"fill":"#6C6B6B","d":"M27.6524 28.7848V8h5.349v20.7848h-5.349ZM5 33.2031h30v-2H5v2Z","key":1})]);
}

ModernTech.defaultProps = {"fill":"none","viewBox":"0 0 40 40"};

module.exports = ModernTech;

ModernTech.default = ModernTech;
